/*
 * General Data Protection Regulation 技术改造
 * 展示notice的站点：en_US|es_ES|pt_BR|fr_FR|it_IT|de_DE|nl_NL|pl_PL
 * 欧盟国家的IP判断展示popup，用户可以用来是否让我们网站使用它的个人cookie
 * cookie信息   ae_u_p_s:string  0:是欧盟国家 1:不同意网站获取用户个人信息  2:同意网站获取用户信息
 * author:sarah.wangxj
 */
'use strict';
import Mtop from '@alife/zoro-mtop';
import Cookie from '@alife/zoro-cookie';
import StoreProxy from '@alife/zoro-store-proxy';

const _showNotice = function (params) {
    //非欧美国家直接退回
    if (!params || !params.isInEU) return;

    let element = document.getElementById('j-aliexpress-notice');
    if (!element || !element.querySelector) {
        return;
    }
    let closeEle = element.querySelector('[data-role=close]');
    // 展示提示
    element.style.display = 'block';
    //欧盟国家写cookie
    Cookie.setAeUps('0');
    closeEle && closeEle.addEventListener('click', function () {
        element.style.display = 'none';
        let nextShowTime = new Date().getTime() + 13 * 30 * 24 * 60 * 60 * 1000;
        Cookie.setAeUpsTime(String(nextShowTime));
        StoreProxy.set('AliexpressNoticeHidden', 'true')
    });
};

const _getNoticeTime = function () {
    if (new Date().getTime() > parseInt(Cookie.getAeUpsTime(), 10)) {
        _showNotice({
            isInEU: true
        });
    }
};

const _buildNotice = function () {
    let userAeUps = Cookie.getAeUps();

    if (userAeUps === '1' || userAeUps === '2') {
        _getNoticeTime();
        return;
    }
    if (userAeUps === '0') {
        StoreProxy.get('AliexpressNoticeHidden', function (err, data) {
            //用户关闭tips之后，13个月后需要在弹出Tips
            if (err || data) {
                _getNoticeTime();
                return;
            }
            _showNotice({
                isInEU: true
            });
        });
        return;
    }

    if (!userAeUps) {
        Mtop.request({
            api: 'mtop.aliexpress.lighthouse.config.get',
            v: '1.0',
            ecode: 0,
            type: 'GET',
            appKey: 24770048,
            dataType: 'jsonp',
            timeout: 3000
        }).then((resJson) => {
            if (!resJson || !resJson.data || !resJson.data.isInEU) {
                return;
            }
            _showNotice(resJson.data);
        })
    }
};

module.exports = _buildNotice;